import { checkIncompleteField } from 'components/form_builder/features/data/dataSlice'
import React, { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import useSelectedKeys from '../hooks/useSelectedKeys'

const Nav = ({ navLabels, onLabelClick, classes }) => {
  const [activeLabel, setActiveLabel] = useState(navLabels[0])
  const selectedKeys = useSelectedKeys()
  const allData = useSelector(({ data }) => data)

  const handleClick = (value) => {
    onLabelClick(value)
    setActiveLabel(value)
  }

  const numberAreasForIncompleteFields = useMemo(() => {
    if (selectedKeys.length === 1) {
      const key = selectedKeys[0].split('.')
      const template = allData[key[0]][key[1]]
      if (checkIncompleteField(key[0], template)) return 1
      return 0
    }
    return 0
  }, [selectedKeys, allData])

  return (
    <div className={`sidebar-nav ${classes ?? ''}`}>
      {navLabels.map((label, idx) => (
        <div
          key={idx}
          id={label}
          className={`nav-link ${activeLabel === label ? 'active' : ''}`}
          onClick={() => handleClick(label)}
        >
          <div className="dome-d-flex dome-gap3">
            <span>{label.toLowerCase()}</span>
            {label === 'Data' && numberAreasForIncompleteFields ? (
              <div
                className="dome-d-flex dome-align-center dome-justify-center"
                style={{ width: 19, height: 19, borderRadius: 20, background: '#E4F2F5' }}
              >
                <span className="dome-p3 dome-color-aqua">{numberAreasForIncompleteFields}</span>
              </div>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  )
}

export default Nav
